export default "__VITE_ASSET__w$52EZZ4__"